// Frontend version. Bump when shipping a new build.
export const APP_VERSION = "1.1.0";
export const BUILD_DATE = "2026-02";
